import { Loader2 } from "lucide-react"
import { cn } from "@/lib/utils"

// The chapter statuses the coach sees (Chapter#status), in book order.
export const CHAPTER_STATUS = {
  needs_info: { label: "Needs info", className: "bg-amber-50 text-amber-800 border-amber-200", bar: "bg-amber-400" },
  ready_to_draft: { label: "Ready to draft", className: "bg-sky-50 text-sky-800 border-sky-200", bar: "bg-sky-400" },
  drafting: { label: "Drafting", className: "bg-violet-50 text-violet-800 border-violet-200", bar: "bg-violet-400", busy: true },
  ready_for_review: { label: "Ready for review", className: "bg-blue-50 text-blue-800 border-blue-200", bar: "bg-blue-500" },
  revision_requested: { label: "Revision requested", className: "bg-violet-50 text-violet-800 border-violet-200", bar: "bg-violet-400", busy: true },
  approved: { label: "Approved", className: "bg-emerald-50 text-emerald-800 border-emerald-200", bar: "bg-emerald-500" },
}

export const STATUS_ORDER = ["approved", "ready_for_review", "revision_requested", "drafting", "ready_to_draft", "needs_info"]

export function StatusChip({ status, className }) {
  const meta = CHAPTER_STATUS[status] || CHAPTER_STATUS.needs_info
  return (
    <span className={cn("inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap", meta.className, className)}>
      {meta.busy && <Loader2 className="h-3 w-3 animate-spin" />}
      {meta.label}
    </span>
  )
}

export function formatDate(iso) {
  if (!iso) return ""
  return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })
}
